import { Button, DialogContent, DialogTitle } from '@atlas/ui-primitives'

export interface UnsavedChangesDialogProps {
	isOpen: boolean
	onDiscard: () => void
	onKeepEditing: () => void
}

/**
 * The unsaved-navigation warning boundary — feature-local, reserved for the
 * form's navigation guard. Escape keeps editing; leaving is always the
 * explicit, destructive-styled choice.
 */
export function UnsavedChangesDialog({ isOpen, onDiscard, onKeepEditing }: UnsavedChangesDialogProps) {
	return (
		<DialogContent
			size="sm"
			role="alertdialog"
			isOpen={isOpen}
			onOpenChange={(next) => {
				if (!next) onKeepEditing()
			}}
		>
			<DialogTitle>Discard unsaved changes?</DialogTitle>
			<p className="mt-2 text-sm text-ds-text-muted">You have unsaved changes. Leaving this page will discard them.</p>
			<div className="mt-6 flex justify-end gap-3">
				<Button variant="outline" onPress={onKeepEditing}>
					Keep editing
				</Button>
				<Button variant="danger" onPress={onDiscard}>
					Discard changes
				</Button>
			</div>
		</DialogContent>
	)
}
